import { useI18n } from "@/context/I18nContext";
import { fmtSar } from "./coUtils";

/** Count · value · `value_still_in_pos_net` for the current filter, from `GET /co/reports/pos-match`. No charts. */
export function TotalsStrip({ totals, ids, loading }) {
    const { t, lang } = useI18n();
    const sar = lang === "ar" ? "ر.س" : "SAR";
    const num = (v) => new Intl.NumberFormat(lang === "ar" ? "ar-SA" : "en-US").format(v || 0);
    const still = totals?.value_still_in_pos_net || { count: 0, value: 0 };
    const tiles = [
        { id: ids.totalCount, label: t("co_rec_total_count"), value: num(totals?.count), raw: totals?.count ?? 0 },
        { id: ids.totalValue, label: t("co_rec_total_value"), value: `${fmtSar(totals?.value_total || 0, lang) || "0"} ${sar}`,
          raw: totals?.value_total ?? 0 },
        { id: ids.totalStill, label: t("co_rec_total_still"), value: `${fmtSar(still.value || 0, lang) || "0"} ${sar}`,
          sub: num(still.count), raw: still.value ?? 0, accent: true },
    ];
    return (
        <section data-testid={ids.totals} data-loading={loading ? "true" : "false"} className="space-y-1.5">
            <div className={`grid grid-cols-3 gap-2 transition-opacity duration-200 ${loading ? "opacity-60" : "opacity-100"}`}>
                {tiles.map((tile) => (
                    <div key={tile.id}
                         className={`min-w-0 rounded-[var(--radius-md)] border px-2.5 py-2 ${tile.accent
                             ? "border-[color:var(--brand-orange)]/40 bg-[color:var(--brand-orange-soft)]"
                             : "border-[color:var(--border-soft)] bg-[color:var(--bg-surface)]"}`}>
                        <p className="text-[10px] font-bold leading-tight text-[color:var(--ink-muted)]">{tile.label}</p>
                        <p data-testid={tile.id} data-value={tile.raw} className="mt-1 truncate text-sm font-extrabold text-[color:var(--ink)] sm:text-base">
                            {tile.value}
                        </p>
                        {tile.sub ? <p className="text-[10px] font-semibold text-[color:var(--ink-faint)]">× {tile.sub}</p> : null}
                    </div>
                ))}
            </div>
            <p className="text-[10px] text-[color:var(--ink-faint)]">{t("co_rec_totals_note")}</p>
        </section>
    );
}
